import { ApprovalOddsTranslations } from '../../../components/ApprovalOddsBadge/i18n';
import {
  staticText,
  brandSpecificStaticText,
} from '../../../utils/translations/staticText';
import money101Translation from './money101';
import moneyHeroTranslation from './moneyhero';
import moneyMaxTranslation from './moneymax';

export const ComparisonTableTranslations = staticText({
  ...ApprovalOddsTranslations,
  no_personal_loans_title: {
    _: 'No Personal Loans Match Your Criteria',
    zh: '搵唔到符合你條件嘅私人貸款計劃',
  },
  no_personal_loans_subtitle: {
    _: 'Try adjusting your loan amount or tenure to see more options.',
    zh: '試下調整你嘅貸款金額或還款期，可能會有更多選擇',
  },
  INTRODUCTORY_ANNUAL_RATE: {
    _: 'Introductory Ann. Rate',
    zh: '最低貸款利率',
  },
  MAXIMUM_LOAN_AMOUNT: {
    _: 'Max Loan Amount',
    zh: '最高貸款額',
  },
  INTRODUCTORY_MONTHLY_REPAYMENT: {
    _: 'Introductory Monthly Repayment',
    zh: '最低每月還款額',
  },

  // From base translations
  apply: {
    _: 'Apply',
    zh: '立即申請',
  },
  card: {
    _: 'Card',
    zh: '信用卡',
  },
  calculateErrorPlaceholderMessage: {
    _: 'Check Provider',
    zh: '稍後查看',
  },
  loan: {
    _: 'Loan',
    zh: '銀行/財務公司',
  },

  brand_reward: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  brand_reward_stk_bka: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  hot_reward_pick: {
    _: 'Hot Reward Pick',
    zh: 'MoneyHero獨家獎賞',
  },
  trending_reward_pick: {
    _: 'Trending Reward',
    zh: '热门奖励精选',
  },
  monthly_repayment: {
    _: 'Monthly Repayment',
    zh: '每月還款額',
  },
  annual_interest_rate: {
    _: 'Annual Interest Rate',
    zh: '年利率',
  },
  total_cost_of_loan: {
    _: 'Total Cost of Loan',
    zh: '總利息',
  },
  eir: {
    _: 'EIR',
    zh: '最低實際年利率',
  },
  interest_rate: {
    _: 'Interest rate',
  },
  interest_rate_from: {
    _: 'From',
  },
  handling_fee: {
    _: 'Handling Fee',
    zh: '手續費',
  },
  ratings_column_header: {
    _: 'Google Ratings',
    zh: 'Google 評分',
  },
  why_apply_now: {
    _: 'Highlights',
    zh: '亮點推薦',
  },

  product: {
    _: 'Product',
    zh: '產品',
  },
  product_bka: {
    _: 'Product Name',
    zh: '銀行戶口',
  },
  product_stk: {
    _: 'Product Name',
    zh: '投資戶口',
  },
  product_ci: {
    _: 'Product Name',
    zh: '保險公司',
  },
  product_ti: {
    _: 'Product Name',
    zh: '保險公司',
  },

  show_all_cards: {
    _: 'Show All Cards',
    zh: '更多精選信用卡',
  },
  show_all_travel_insurance_products: {
    _: 'Show All Products',
  },
  show_all_car_insurance_products: {
    _: 'Show All Products',
  },
  show_all_banking_products: {
    _: 'Show All Products',
    zh: '顯示所有銀行戶口',
  },
  show_all_investment_products: {
    _: 'Show All Products',
    zh: '顯示所有投資戶口',
  },
  show_all_loans: {
    _: 'Show All Loans',
    zh: '顯示所有貸款',
  },

  // Row labels (CMS-1906); title case here, uppercased by CSS in the rail.
  row_label_our_pick: {
    _: 'Our Pick',
    zh: '編輯精選',
  },
  row_label_exclusive: {
    _: 'Exclusive',
    zh: '獨家',
  },
  row_label_ends_soon: {
    _: 'Ends Soon',
    zh: '即將結束',
  },
  row_label_flash_deal: {
    _: 'Flash Deal',
    zh: '限時搶購',
  },
  row_label_new: {
    _: 'New',
    zh: '全新上架',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: ComparisonTableTranslations,
  moneyhero: moneyHeroTranslation,
  money101: money101Translation,
  moneymax: moneyMaxTranslation,
});

export type ComparisonTableTranslations = typeof TRANSLATIONS;
